// Where the coordinator is in the portal, kept for this browser tab only, so
// refreshing the page (after correcting the EPS, say) returns to the same
// screen and packet. Cleared on sign-out.

export const TAB_KEY = 'deliveryPortalTab';
export const PACKET_VIEW_KEY = 'deliveryPortalPacketView';

export function readView(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

export function writeView(key, value) {
  try {
    if (value == null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, JSON.stringify(value));
  } catch (_) {
    /* storage unavailable: a refresh simply starts at home */
  }
}

export function clearViews() {
  writeView(TAB_KEY, null);
  writeView(PACKET_VIEW_KEY, null);
}
